<template>
    <div class="flex flex-col max-w-screen-xl mx-auto px-8 lg:px-32 gap-y-4">
        <h1 class="text-2xl text-san-marino-600 font-semibold mt-4 lg:mt-24">
            Hüküm ve Koşullar
        </h1>
        <div class="text-san-marino-800 mt-2">
            <span class="font-semibold">Son güncelleme:</span> 22 Kasım 2024
        </div>

        <div class="text-lg text-san-marino-600 font-medium mt-4">
            1. TANIMLAR VE KAPSAM
        </div>
        <div class="text-san-marino-800">
            <div class="mb-2">
                1.1. Bu sözleşme, Amerika Birleşik Devletleri'nde kurulu LOKUM
                TECH LLC ("Şirket") tarafından işletilen Kolay eSIM markası
                altında sunulan hizmetlerin kullanım şartlarını düzenlemektedir.
            </div>
            <div class="mb-2">
                1.2. "Müşteri", Kolay eSIM hizmetlerini kullanmak üzere kayıt
                olan ve 18 yaşını doldurmuş gerçek kişiler ile tüzel kişileri
                ifade eder.
            </div>
            <div class="mb-2">
                1.3. "Platform", www.kolayesim.com alan adı üzerinden
                erişilebilen web sitesi ve ilgili tüm dijital hizmetleri kapsar.
            </div>
            <div class="mb-2">
                1.4. "eSIM", fiziksel SIM kart gerektirmeden mobil hizmetlerin
                kullanılmasını sağlayan dijital SIM teknolojisini ifade eder.
            </div>
            <div>
                1.5. "Hizmet", uluslararası seyahatlerde kullanılmak üzere
                dijital eSIM data paketlerinin satışını, aktivasyonunu ve bu
                paketlere ilişkin müşteri desteğini kapsar.
            </div>
        </div>

        <div class="text-lg text-san-marino-600 font-medium mt-4">
            2. HİZMETİN KULLANIMI
        </div>
        <div class="text-san-marino-800">
            <div class="mb-2">
                2.1. Müşteri, cihazının eSIM uyumlu olmasını ve ağ kilidinin
                açık olmasını sağlamaktan sorumludur. Cihaz uyumluluğu operatöre
                ve menşe ülkeye bağlı olabilir; Müşterinin, Platformda sağlanan
                eSIM uyumlu cihazların listesini kontrol etmesi gerekir.
            </div>
            <div class="mb-2">
                2.2. Satın alınan eSIM paketleri, belirtilen süre ve data
                limitleri dahilinde kullanılmalıdır.
            </div>
            <div class="mb-2">
                2.3. Müşteri, eSIM profilini yalnızca bir cihazda aktive
                edebilir ve profil bir kez aktive edildikten sonra başka bir
                cihaza transfer edilemez.
            </div>
            <div class="mb-2">
                2.4. Hizmetin kullanımı için gerekli olan QR kod ve aktivasyon
                bilgileri müşterinin kayıtlı e-posta adresine gönderilecektir.
            </div>
            <div>
                2.5. Müşteri, satın aldığı eSIM paketinin geçerlilik süresi ve
                kalan data miktarını Platform üzerinden takip edebilir.
            </div>
        </div>

        <div class="text-lg text-san-marino-600 font-medium mt-4">
            3. ÖDEME VE İADE KOŞULLARI
        </div>
        <div class="text-san-marino-800">
            <div class="mb-2">
                3.1. Ödemeler Türk Lirası (TRY) veya Amerikan Doları (USD)
                cinsinden yapılabilir. Döviz kurları, ödeme anındaki güncel
                piyasa kurlarına göre belirlenir.
            </div>
            <div class="mb-2">
                3.2. Platform üzerinden yapılan ödemeler, güvenli ödeme
                altyapısı sağlayıcımız Stripe tarafından işlenmektedir. Ödeme
                işlemleri SSL protokolü ile şifrelenmiştir.
            </div>
            <div class="mb-2">
                3.3. Kabul edilen ödeme yöntemleri arasında kredi kartı ve diğer
                elektronik ödeme sistemleri bulunmaktadır.
            </div>
            <div class="mb-2">
                3.4. Aktivasyon yapılmamış eSIM paketleri için satın alma
                tarihinden itibaren 14 gün içinde iade talep edilebilir. İade
                talepleri destek@kolayesim.com adresine iletilmelidir.
            </div>
            <div class="mb-2">
                3.5. Aktivasyon yapılmış eSIM paketleri için iade
                yapılmamaktadır.
            </div>
            <div>
                3.6. İade işlemlerinde, ödeme yapılan para birimi ve ödeme
                yöntemi üzerinden iade gerçekleştirilir. İade süreci, bankanın
                işlem süresine bağlı olarak 3-7 iş günü içinde tamamlanır.
            </div>
        </div>

        <div class="text-lg text-san-marino-600 font-medium mt-4">
            4. SORUMLULUK SINIRLAMALARI
        </div>
        <div class="text-san-marino-800">
            <div class="mb-2">
                4.1. Şirket, telekomünikasyon altyapısından kaynaklanan kesinti
                ve arızalardan sorumlu değildir.
            </div>
            <div>
                4.2. Müşteri, satın aldığı eSIM paketinin kullanılacağı ülkedeki
                yerel düzenlemelere uymakla yükümlüdür.
            </div>
        </div>

        <div class="text-lg text-san-marino-600 font-medium mt-4">
            5. KİŞİSEL VERİLERİN KORUNMASI
        </div>
        <div class="text-san-marino-800">
            <div class="mb-2">
                5.1. Şirket, 6698 sayılı Kişisel Verilerin Korunması Kanunu
                kapsamında müşteri verilerini işlemekte ve korumaktadır.
            </div>
            <div>
                5.2. Toplanan veriler yalnızca hizmet sunumu ve yasal
                yükümlülükler kapsamında kullanılacaktır.
            </div>
        </div>

        <div class="text-lg text-san-marino-600 font-medium mt-4">
            6. İLETİŞİM
        </div>
        <div class="text-san-marino-800 mb-24">
            <div class="mb-2">
                6.1. Her türlü soru ve destek talebi için: destek@kolayesim.com
            </div>
            <div>
                6.2. Yasal bildirimler için: LOKUM TECH LLC, 8 The Green, Suite
                A, Dover 19901
            </div>
        </div>
    </div>
</template>

<script setup lang="ts">
useSeoMeta({
    title: "Hüküm ve Koşullar",
    description: "Kolay eSIM'in hüküm ve koşulları",
});
</script>
